import React from "react";
import PropTypes from "prop-types";
import { EVENT_CODE_ENTER } from "../../constants";

/**
 * Contract Holder Program Performance Table Column Header Component
 * @param {Object} props
 * @param {string} props.id
 * @param {string} props.className
 * @param {function} props.onClick
 * @param {string} props.title
 * @param {React.ReactNode} props.children
 * @returns {Element}
 * @constructor
 */
export default function TableHeaderColumn({ id, className, onClick, title, children }) {
  return (<th id={id} className={className} title={title} onClick={onClick} role="columnheader"
              onKeyDown={event => {
                if (event.key === EVENT_CODE_ENTER) {
                  onClick(event);
                }
              }}
              tabIndex={onClick ? 0 : -1}>
    {children}
  </th>);
}

TableHeaderColumn.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
}